import { patchState, signalStoreFeature, withMethods, withState } from '@ngrx/signals';
import { FilterConfig } from '@packages/filter';

type FilterState = { filterConfig: FilterConfig.FullFilterItemConfig[]; currentFilterList: FilterConfig.FullFilterItemConfig[] };

export function withFilter() {
  return signalStoreFeature(
    withState<FilterState>({ filterConfig: [], currentFilterList: [] }),
    withMethods((store) => ({
      setCurrentFilterList: (currentFilterList: FilterConfig.FullFilterItemConfig[]) => {
        patchState(store, { currentFilterList });
      },
      setFilterConfig: (filterConfig: FilterConfig.FullFilterItemConfig[]) => patchState(store, { filterConfig }),
    })),
  );
}
